module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "options-container"
  }, [_c('div', {
    staticClass: "options-head"
  }, [_c('div', {
    staticClass: "options-heading drag-wrapper"
  }), _vm._v(" "), _c('div', {
    staticClass: "options-heading button-wrapper"
  }), _vm._v(" "), _c('div', {
    staticClass: "options-heading label-wrapper"
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.drag_editor.active_item.label')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "options-heading value-wrapper"
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.drag_editor.active_item.value')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "options-heading delete"
  })]), _vm._v(" "), _c('drag-container', {
    ref: "container",
    attrs: {
      "groupName": "optionsDrag",
      "collection": _vm.internalCollection,
      "shouldRemoveOnDrop": false,
      "shouldAcceptDrops": true,
      "nonDragAreaSelector": "input",
      "dropPlaceholderOptions": {
        className: 'drag-ghost-options'
      },
      "dragClass": "drag-dragging-options",
      "lockAxis": "y",
      "behaviour": "contain"
    },
    on: {
      "onDrop": _vm.onDrop
    }
  }, _vm._l((_vm.internalCollection), function(item, idx) {
    return _c('Draggable', {
      key: idx,
      staticClass: "drag-item option-row"
    }, [_c('div', {
      staticClass: "options-table-content"
    }, [_c('div', {
      staticClass: " drag-wrapper options-drag-icon"
    }, [_c('img', {
      staticClass: "drag-icon",
      attrs: {
        "src": _vm.dragIcon
      }
    })]), _vm._v(" "), (_vm.element_type != 'quantity_selection') ? _c('div', {
      staticClass: " button-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internalDefaultValue),
        expression: "internalDefaultValue"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": item.value,
        "false-value": null,
        "id": idx
      },
      domProps: {
        "value": item.value,
        "checked": true,
        "checked": Array.isArray(_vm.internalDefaultValue) ? _vm._i(_vm.internalDefaultValue, item.value) > -1 : _vm._q(_vm.internalDefaultValue, item.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.internalDefaultValue,
            $$el = $event.target,
            $$c = $$el.checked ? (item.value) : (null);
          if (Array.isArray($$a)) {
            var $$v = item.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.internalDefaultValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.internalDefaultValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.internalDefaultValue = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (!_vm.isEditing(item, 'name')) ? _c('div', {
      staticClass: " label-wrapper"
    }, [_c('span', {
      staticClass: "caption truncate-text v-align-super"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('i', {
      staticClass: "icon yule-icon-edit edit action-icon",
      on: {
        "click": function($event) {
          return _vm.setEditing(item, 'name')
        }
      }
    })]) : _c('div', {
      staticClass: "input label-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internalCollection[idx].name),
        expression: "internalCollection[idx].name"
      }],
      ref: "editing",
      refInFor: true,
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.internalCollection[idx].name)
      },
      on: {
        "blur": _vm.removeEditing,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.internalCollection[idx], "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), (!_vm.isEditing(item, 'value') || _vm.limitEditing) ? _c('div', {
      staticClass: " value-wrapper"
    }, [_c('span', {
      staticClass: "caption truncate-text v-align-super"
    }, [_vm._v("\n            " + _vm._s(item.value) + "\n          ")]), _vm._v(" "), (!_vm.limitEditing) ? _c('i', {
      staticClass: "icon yule-icon-edit edit action-icon",
      on: {
        "click": function($event) {
          return _vm.setEditing(item, 'value')
        }
      }
    }) : _vm._e()]) : _c('div', {
      staticClass: " value-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internalCollection[idx].value),
        expression: "internalCollection[idx].value"
      }],
      ref: "editing",
      refInFor: true,
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.internalCollection[idx].value)
      },
      on: {
        "blur": _vm.removeEditing,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.internalCollection[idx], "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: " delete"
    }, [(!_vm.limitEditing) ? _c('i', {
      staticClass: "icon yule-icon-trash action-icon",
      on: {
        "click": function($event) {
          return _vm.deleteElement(item)
        }
      }
    }) : _vm._e()])])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d68ede6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/DragEditorItemOptions.vue
// module id = 1920
// module chunks = 0